import React from 'react';
import { useTranslation } from 'react-i18next';
import { FileDown } from 'lucide-react';

/** Placeholder: AI Export ruta da navigacija ne vodi na početnu. */
const AIExportView = () => {
  const { t } = useTranslation();
  return (
    <div className="bg-gray-900 min-h-screen p-4 sm:p-6">
      <div className="max-w-3xl mx-auto space-y-4">
        <div className="bg-gray-800 rounded-xl border border-gray-700 p-6 flex items-start gap-4">
          <div className="bg-violet-500/20 rounded-lg p-3">
            <FileDown className="h-8 w-8 text-violet-400" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-white">AI Export</h1>
            <p className="text-gray-400 mt-2 text-sm leading-relaxed">
              {t(
                'aiExport.placeholder',
                'Modul za AI-pomognuti izvoz podataka je u pripremi. Do tada koristite standardne izvozne opcije u sekcijama Klijenti, Poslovi i Rezervni delovi.'
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIExportView;
